export const RocketMessageId = {
  login: "8121",
  getRooms: "8122",
  getSubscribedRooms: "8123",
};

export enum RocketSocketStatus {
  NONE = 0, // WebSocket closed (or initial closed state)
  CONNECTING = 1, // WebSocket connection attempted
  OPEN = 2, // WebSocket TCP connection established (onopen fired)
  CONNECTED = 3, // Server responded with "connected" handshake message
  AUTHENTICATED = 4, // Login successful, fully authenticated and ready
  ERROR = 9, // WebSocket error occurred
}
